<template>
  <div class="dialog-container" v-show="isShow" style="z-index:2007">
    <div class="dialog" style="z-index:2007">
      <div class="dialog-header">{{title}}</div>
      <div class="dialog-content">{{content}}</div>
      <div class="dialog-footer">
        <button @click="confirm">知道了</button>
      </div>
    </div>
    <div class="modal" style="z-index:2006"></div>
  </div>
</template>
<style scoped>
.dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 62%;
  font-size: 16px;
  overflow: hidden;
  -webkit-transition: .2s;
  transition: .2s;
  border-radius: 4px;
  background-color: #fff;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  line-height: 1.5;
  padding: 30px 35px;
  .dialog-header {
    padding: 25px 0 0;
    text-align: center;
    font-size: 32px;
  }
  .dialog-content {
    font-size: 28px;
    text-indent: 2em;
    color: #999;
    padding: 30px 0;
    line-height: 60px;
  }
  .dialog-footer {
    text-align: center;
    button {
      border: 0;
      color: #00c000;
      width: 100%;
      height: 60px;
      line-height: 48px;
      font-size: 32px;
      background-color: white;
    }
  }
}

.modal {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
}
</style>
<script>
export default {
  data() {
    return {
      timer: null,
      msg: ""
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
  },
  methods: {
    confirm () {
      this.$emit('confirm');
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/template/dialog/index.vue